
import React, { Dispatch, SetStateAction } from 'react';
import { Chip, createStyles, Grid, Icon, makeStyles, Typography } from '@material-ui/core';
import { EditAction } from '../../../../shared/enum/EditAction';
import { BatchDto } from '../../../../Models/BatchDto';
import { BatchModel, batchModelInitial } from '../../../../Models/BatchModel';

interface IBatchCorrectionRemove {
    list: BatchDto[],
    setList: Dispatch<SetStateAction<BatchDto[]>>
    removed: BatchModel[],
    setRemoved: Dispatch<SetStateAction<BatchModel[]>>
    searchText?: string
}

const useStyles = makeStyles(() => createStyles({
    chipItem: {
        margin: '4px',
    }
}));

export function BatchCorrectionRemove({list, setList, removed, setRemoved, searchText} : IBatchCorrectionRemove) {
    const classes = useStyles();

    const handleSelectToRemove = (data: BatchDto) => {
        let value: BatchModel = batchModelInitial;

        if ('journalist' in data)
            value = data.journalist;
        else if ('source' in data)
            value = data.source;
        else if ('keyword' in data)
            value = data.keyword;
        else if ('exposition' in data)
            value = data.exposition;

        const currentList: BatchDto[] = JSON.parse(JSON.stringify(list));
        const index = currentList.findIndex((data: BatchDto) => {
            return findBatchIndex(data, value);
        });
        
        currentList[index].editAction = EditAction.DELETE;

        const listToRemove = JSON.parse(JSON.stringify(removed));
        
        if (value) {
            value.editAction = EditAction.DELETE;
            listToRemove.push(value);
        }

        setList(currentList);
        setRemoved(listToRemove);
    };

    const handleRestore = (value: BatchModel) => {
        const listToRemove = JSON.parse(JSON.stringify(removed));
        const index = listToRemove.findIndex((v : BatchModel) => v.id == value.id);
        listToRemove.splice(index, 1);

        const listToRestore = JSON.parse(JSON.stringify(list));
        const indexToRestore = listToRestore.findIndex((data : BatchDto) => {
            return findBatchIndex(data, value);
        });
        listToRestore[indexToRestore].editAction = EditAction.NONE;

        setRemoved(listToRemove);
        setList(listToRestore);
    };

    const findBatchIndex = (data: BatchDto, value: BatchModel)  => {
        if ('journalist' in data)
            return (data.journalist.id == value.id);
        else if ('source' in data)
            return (data.source.id == value.id);
        else if ('keyword' in data)
            return (data.keyword.id == value.id);
        else if ('exposition' in data)
            return (data.exposition.id == value.id);
        else 
            return false;
    };
    
    const getList = () => {
        const listFilter = (searchText && searchText != '') ?
            list.reduce(function (filtered: BatchDto[], value) {
                if ('keyword' in value && value.keyword.description && value.keyword.description.toLowerCase().includes(searchText.toLowerCase()))
                    filtered.push(value);

                return filtered;
            }, []) : list;

        return (
            <Grid item xs={12}>
                {listFilter.map((value) => {
                    if (value.editAction != EditAction.DELETE)
                        return <Chip
                            key={('journalist' in value ? value.journalist.id : 0) || 
                                ('source' in value ? value.source.id : 0) || 
                                ('keyword' in value ? value.keyword.id : 0) ||
                                ('exposition' in value ? value.exposition.id : 0)}
                            label={('journalist' in value ? value.journalist.name : 0) || 
                                ('source' in value ? value.source.name : 0) || 
                                ('keyword' in value ? value.keyword.description : 0) ||
                                ('exposition' in value ? value.exposition.name : 0)}
                            className={classes.chipItem}
                            deleteIcon={<Icon>close</Icon>}
                            onDelete={() => {
                                handleSelectToRemove(value);
                            }}
                            onClick={() => {
                                handleSelectToRemove(value);
                            }}
                            color='primary'
                            variant={!value.both ? 'outlined' : 'default'}
                        />;
                })}
            </Grid>
        );
    };

    const getRemovedList = () => {
        return (
            <Grid 
                container 
                direction="row"
                justify="flex-start"
                alignItems="center">
                <Grid item>
                    <Typography variant='body2'>Removidas: </Typography>
                </Grid>
                <Grid item>
                    {removed.map((value) => {
                        return <Chip
                            key={value.id}
                            label={'name' in value ? value.name : '' || 'description' in value ? value.description : ''}
                            className={classes.chipItem}
                            deleteIcon={<Icon>close</Icon>}
                            onDelete={() => {
                                handleRestore(value);
                            }}
                            onClick={() => {
                                handleRestore(value);
                            }}
                            color='primary'
                        />;
                    })}
                </Grid>
            </Grid>
        );
    };

    
    return (
        <>
            { list.length > 0 && getList() }
            { removed.length > 0 && getRemovedList() }
        </>
    );
}